module.exports = "/fonts/vendor/boxicons/boxicons.eot?342c527555cfdb9d35b5dd5629b3fa37";